import * as QueryString from "querystring";
import { AUTH_QUERY_PARAMS } from "./constants";
import { QueryParams } from "@/utils/functions/buildSafeUrl";

export const getAuthQueryParams = (locationURl?: string): QueryParams => {
  if (typeof window === "undefined") {
    return {};
  }
  const urlParams: QueryString.ParsedUrlQuery = locationURl
    ? QueryString.parse(new URL(locationURl).searchParams.toString())
    : QueryString.parse(window.location.search);
  const params: QueryParams = {};
  Object.entries(urlParams).forEach(([key, value]) => {
    let cleanKey = key;
    if (key.startsWith("?")) {
      cleanKey = key.replace("?", "");
    }
    if (AUTH_QUERY_PARAMS.indexOf(cleanKey) > -1) {
      params[cleanKey] = value;
    }
  });
  return params;
};
